import { ReactComponent as EmptyStateSearchIcon } from 'assets/svg/emptyStateSearchIcon.svg'

export const emptyStateProps = {
  title: 'Sem resultados',
  message: 'Nenhum registro foi encontrado nesta seção',
  Icon: EmptyStateSearchIcon,
}

export const ALL_ORIGIN_NAMES = 'Todas'
